"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Rewards API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.VoucherRewardTypeToJSON = exports.VoucherRewardTypeFromJSONTyped = exports.VoucherRewardTypeFromJSON = exports.VoucherRewardType = void 0;
/**
 * Voucher reward type
 * @export
 */
exports.VoucherRewardType = {
    DropKey: 'dropKey',
    DropCode: 'dropCode'
};
function VoucherRewardTypeFromJSON(json) {
    return VoucherRewardTypeFromJSONTyped(json, false);
}
exports.VoucherRewardTypeFromJSON = VoucherRewardTypeFromJSON;
function VoucherRewardTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.VoucherRewardTypeFromJSONTyped = VoucherRewardTypeFromJSONTyped;
function VoucherRewardTypeToJSON(value) {
    return value;
}
exports.VoucherRewardTypeToJSON = VoucherRewardTypeToJSON;
